<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-app>
    <template v-if="isMaintenanceMode">
      <div className="maintenance-mode">
        <img v-if="imageDesk" class="image-maintenance-desk" :src="imageDesk" alt="Maintenance Mode" />
        <img v-if="imageMobile" class="image-maintenance-mobile" :src="imageMobile" alt="Maintenance Mode" />
      </div>
    </template>
    <template v-else>
      <router-view />
    </template>
  </v-app>
</template>

<script>


export default {
  name: 'app',
  data() {
    return {
      isMaintenanceMode: false,
      imageDesk: '',
      imageMobile: '',
    }
  },
  created() {
    // this.checkMaintenanceMode();
  },
  methods: {
    checkMaintenanceMode() {
      const positionStatus = location.host.includes('tcc.smk.agency:9011') || location.host.includes('localhost');
      let url = positionStatus ? 
        'https://dev.smk.agency/falkon/wp-json/general/maintenance' : 
        'https://falkon.com.co/wp-json/general/maintenance';

      fetch(url, {
        method: 'GET',
        headers: {}
      })
        .then(response => response.json())
        .then(data => {
          if (data && data.falkon_transaccional) {
            const maintenanceTransaccional = data.falkon_transaccional;
            const currentDate = new Date();
            const startDate = new Date(maintenanceTransaccional.start);
            const endDate = new Date(maintenanceTransaccional.end);
            const isWithinDateRange = currentDate >= startDate && currentDate <= endDate;

            if (maintenanceTransaccional &&
                maintenanceTransaccional.mode_maintenance &&
                maintenanceTransaccional.mode_maintenance[0] === 'active' &&
                isWithinDateRange
            ) {
              const urlParams = new URLSearchParams(window.location.search);
              const isDeveloperMode = urlParams.get('mode_developer') === 'true';
              if (!isDeveloperMode) {
                this.isMaintenanceMode = true;
                this.imageDesk = maintenanceTransaccional.image && maintenanceTransaccional.image.url ? maintenanceTransaccional.image.url : '';
                this.imageMobile = maintenanceTransaccional.image_mobile && maintenanceTransaccional.image_mobile.url ? maintenanceTransaccional.image_mobile.url : maintenanceTransaccional.image && maintenanceTransaccional.image.url ? maintenanceTransaccional.image.url : '';
              }
            }
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
}
</script>

<style scoped>
.image-maintenance-desk{
    width: 100%;
    @media screen and (max-width: 450px){
        display: none;
    }
}
.image-maintenance-mobile{
    display: none;
    width: 100%;
    @media screen and (max-width: 450px){
        display: block;
    }
}
</style>
